import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./componehts/login/login";
import Register from "./componehts/login/Register";
import Forgot_Password from "./componehts/login/Forgot_Password";
import Reset_Password from "./componehts/login/ResetPassword_New";
import Change_Password from "./componehts/login/Change_Password";
import Dashboard_layout from "./componehts/pages/Dashboard_layout";
import User_layout from "./componehts/pages/User_layout";
import Session_layout from "./componehts/pages/Session_layout";
import Sub_Admins_layout from "./componehts/pages/Sub_Admins_layout";
import Support_layout from "./componehts/pages/Support_layout";
import Guidelines from "./componehts/pages/Guidelines_layout";
import { Types } from "./constants/actionTypes";
import { connect } from "react-redux";
import { useState } from "react";
import PushNotification from "./componehts/pages/Push-notification";
import Report_layout from "./componehts/pages/report_layout";
import Usersdetails_layout from "./componehts/pages/Userdetails_layout";
import Job_layout from "./componehts/pages/Job_layout";
import Verification from "./componehts/login/verification";
import Advertisement_layout from "./componehts/pages/Advertisement_layout";
import Add_Advertisement_layout from "./componehts/pages/Add_Advertisement_layout";
import Edit_Advertisement_layout from "./componehts/pages/Edit_Advertisement_layout";
import MasterOrg_layout from "./componehts/pages/MasterOrg_layout";
import SubOrgs_layout from "./componehts/pages/SubOrgs_layout";
import Organizations_layout from "./componehts/pages/Organizations_layout";
import MasterOrgDashboard_layout from "./componehts/pages/MasterOrgDashboard_layout";
import MasterOrgInviteCodes_layout from "./componehts/pages/MasterOrgInviteCodes_layout";
import MasterOrgJoinRequests_layout from "./componehts/pages/MasterOrgJoinRequests_layout";
import MasterOrgSubOrgs_layout from "./componehts/pages/MasterOrgSubOrgs_layout";
import MasterOrgUsers_layout from "./componehts/pages/MasterOrgUsers_layout";
import MasterOrgAlerts_layout from "./componehts/pages/MasterOrgAlerts_layout";
import MasterOrgAccount_layout from "./componehts/pages/MasterOrgAccount_layout";
import MasterOrgConnect_layout from "./componehts/pages/MasterOrgConnect_layout";
import ClubContent_layout from "./componehts/pages/ClubContent_layout";
import MasterOrgAdvertisements_layout from "./componehts/pages/MasterOrgAdvertisements_layout";
import MasterOrgAddAdvertisement_layout from "./componehts/pages/MasterOrgAddAdvertisement_layout";
import MasterOrgEditAdvertisement_layout from "./componehts/pages/MasterOrgEditAdvertisement_layout";
import MasterOrgAdvertisementAnalytics_layout from "./componehts/pages/MasterOrgAdvertisementAnalytics_layout";
import AdminAlerts_layout from "./componehts/pages/AdminAlerts_layout";
import AdminAccount_layout from "./componehts/pages/AdminAccount_layout";
import Payments_layout from "./componehts/pages/Payments_layout";

function App(props) {
  const [, setIsLoaded] = useState(false);

  return (
    <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="master/register" element={<Register />} />
          <Route path="register" element={<Register />} />
          <Route
            path="master/connect"
            element={
              <MasterOrgConnect_layout
                props={props}
                setIsLoaded={setIsLoaded}
              />
            }
          />
          <Route path="forgotpassword" element={<Forgot_Password />} />
          <Route path="/verification/resetpassword" element={<Reset_Password  />} />
          <Route path="changepassword" element={<Change_Password />} />
          <Route
            path="dashboard"
            element={
              <Dashboard_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="user"
            element={<User_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="session"
            element={<Session_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="advertisement"
            element={<Advertisement_layout props={props} setIsLoaded={setIsLoaded} />}
          />
           <Route
            path="add-advertisement"
            element={<Add_Advertisement_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="edit-advertisement/:id"
            element={<Edit_Advertisement_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="job"
            element={<Job_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="reportfixture"
            element={
              <Sub_Admins_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="report"
            element={
              <Report_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="userdetails"
            element={
              <Usersdetails_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="support"
            element={<Support_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="guidelines"
            element={<Guidelines props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="master-org/dashboard"
            element={
              <MasterOrgDashboard_layout
                props={props}
                setIsLoaded={setIsLoaded}
              />
            }
          />
          <Route
            path="master-org/invite-codes"
            element={
              <MasterOrgInviteCodes_layout
                props={props}
                setIsLoaded={setIsLoaded}
              />
            }
          />
          <Route
            path="master-org/join-requests"
            element={
              <MasterOrgJoinRequests_layout
                props={props}
                setIsLoaded={setIsLoaded}
              />
            }
          />
          <Route
            path="master-org/sub-orgs"
            element={
              <MasterOrgSubOrgs_layout
                props={props}
                setIsLoaded={setIsLoaded}
              />
            }
          />
          <Route
            path="master-org/clubs/:id/content"
            element={
              <ClubContent_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/users"
            element={
              <MasterOrgUsers_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/alerts"
            element={
              <MasterOrgAlerts_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/connect"
            element={
              <MasterOrgConnect_layout
                props={props}
                setIsLoaded={setIsLoaded}
              />
            }
          />
          <Route
            path="master-org/account"
            element={
              <MasterOrgAccount_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/advertisements"
            element={
              <MasterOrgAdvertisements_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/add-advertisement"
            element={
              <MasterOrgAddAdvertisement_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/edit-advertisement/:id"
            element={
              <MasterOrgEditAdvertisement_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/advertisement-analytics"
            element={
              <MasterOrgAdvertisementAnalytics_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-org/advertisement-analytics/:id"
            element={
              <MasterOrgAdvertisementAnalytics_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="master-orgs"
            element={<MasterOrg_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="sub-orgs"
            element={<SubOrgs_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="organizations"
            element={<Organizations_layout props={props} setIsLoaded={setIsLoaded} />}
          />
          <Route
            path="alerts"
            element={
              <AdminAlerts_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="payments"
            element={
              <Payments_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="admin/account"
            element={
              <AdminAccount_layout props={props} setIsLoaded={setIsLoaded} />
            }
          />
          <Route
            path="PushNotification"
            element={
              <PushNotification props={props} setIsLoaded={setIsLoaded} />
            }
          />
           <Route
            path="verification"
            element={
              <Verification props={props} setIsLoaded={setIsLoaded} />
            }
          />

        </Routes>
      </Router>
  );
}

const mapStateToProps = (state) => ({
  profile: state.user.profile,
});

const mapDispatchToProps = (dispatch) => ({
  save_user_data: (data) => dispatch({ type: Types.LOGIN, payload: data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
